import React, { useContext } from 'react'

import { Box, Flex, Header, SimpleGrid, styled } from '@driftt/dds'

import { CurrentUserContext } from 'context/currentUserContext'
import { retrieveName } from 'utils/formatStrings'

import LiveVisitorsCard from './LiveVisitorsCard'

const HeaderContainer = styled(SimpleGrid, {
  padding: '$1 $4 10px',
  height: 'fit-content',
  gap: '$3',
  margin: '$4 auto 0 auto',
  width: '100%'
})

export interface DashboardHeaderProps {
  hasLiveViewFromReach: boolean
}

const DashboardHeader = ({ hasLiveViewFromReach }: DashboardHeaderProps) => {
  const currentUser = useContext(CurrentUserContext)

  return (
    <HeaderContainer
      alignItems="center"
      columns={8}
      css={{
        paddingBottom: '$3'
      }}>
      <Flex
        direction="column"
        css={{
          gridColumn: 'span 6'
        }}
        gap={0}>
        <Header variant="h4">{retrieveName(currentUser)}</Header>
        <Header variant="h1">Prospector dashboard</Header>
      </Flex>

      <Box
        fullWidth
        css={{
          gridColumn: 'span 2'
        }}>
        <LiveVisitorsCard hasLiveViewFromReach={hasLiveViewFromReach} />
      </Box>
    </HeaderContainer>
  )
}

export default DashboardHeader
